module.exports = __webpack_public_path__ + "94784d0ef801cdf14dde2279db8b19f6.pdf";